<div class="payment-settings" [class.payment-settings--embedded-mobile]="isSmallScreenLayout">
  <ng-container *ngIf="!shouldShowBillingContent(); else billingContent">
    <p class="payment-settings-unavailable ion-padding">{{ 'PAYMENT.NOT_AVAILABLE' | translate }}</p>
  </ng-container>

  <ng-template #billingContent>
    <form
      *ngIf="formLoaded"
      [formGroup]="paymentFormGroup"
      (focusin)="scrollFormFieldIntoView($event)"
    >
      <section class="payment-section payment-subscription-fields">
        <div class="payment-section-title-row">
          <h2 class="payment-section-title">{{ 'PAYMENT.SUBSCRIPTION' | translate }}</h2>
          <ion-button
            fill="outline"
            size="small"
            color="medium"
            (click)="openSubscriptionHistory()"
          >
            {{ 'PAYMENT.HISTORY' | translate }}
          </ion-button>
        </div>
        <ion-item *ngIf="hasSubscriptionDetails">
          <ion-input
            disabled="true"
            [label]="'PAYMENT.STATUS' | translate"
            [labelPlacement]="subscriptionFieldLabelPlacement"
            [value]="subscriptionStatusDisplay"
            class="ion-text-right payment-readonly-field"
          ></ion-input>
        </ion-item>
        <ion-item *ngIf="hasSubscriptionDetails">
          <ion-input
            disabled="true"
            [label]="'PAYMENT.FIRST_BILLING_DATE' | translate"
            [labelPlacement]="subscriptionFieldLabelPlacement"
            [value]="firstBillingDateDisplay"
            class="ion-text-right payment-readonly-field"
          ></ion-input>
        </ion-item>
        <ion-item>
          <ion-input
            disabled="true"
            [label]="'PAYMENT.CURRENT_EXPIRATION' | translate"
            [labelPlacement]="subscriptionFieldLabelPlacement"
            [class.danger]="subscriptionLapsed()"
            [value]="expirationDisplay"
            class="ion-text-right payment-readonly-field"
          ></ion-input>
        </ion-item>
      </section>

      <section class="payment-section payment-subscription-actions">
        <ion-item *ngIf="shouldShowStartSubscription()" [class.payment-item-actions-stacked]="fieldLabelPlacement === 'stacked'">
          <ion-label>{{ 'GENERAL.START_SUBSCRIPTION' | translate }}</ion-label>
          <ion-button slot="end" color="primary" (click)="startSubscription()" [disabled]="updatePending || !canStartSubscription()">
            {{ 'GENERAL.START_SUBSCRIPTION' | translate }}
          </ion-button>
        </ion-item>
        <ion-item *ngIf="shouldShowRenewSubscription()" [class.payment-item-actions-stacked]="fieldLabelPlacement === 'stacked'">
          <ion-label>{{ 'GENERAL.RENEW_SUBSCRIPTION' | translate }}</ion-label>
          <ion-button slot="end" color="primary" (click)="subscribe()" [disabled]="updatePending || !canSubscribe()">
            {{ 'GENERAL.SUBSCRIBE' | translate }}
          </ion-button>
        </ion-item>
        <ion-item *ngIf="shouldShowPaymentManagement() && subscriptionStatusDisplay !== 'Active'" class="cost-per-year-item">
          <ion-label>{{ 'GENERAL.COST_PER_YEAR' | translate }} $19.99/year</ion-label>
        </ion-item>
        <ion-item *ngIf="shouldShowCancelSubscription()" [class.payment-item-actions-stacked]="fieldLabelPlacement === 'stacked'">
          <!-- <ion-label>{{ 'GENERAL.CANCEL_SUBSCRIPTION' | translate }}</ion-label> -->
          <ion-button slot="end" color="medium" fill="outline" size="small" (click)="cancelSubscription()" [disabled]="updatePending">
            {{ 'GENERAL.CANCEL_SUBSCRIPTION' | translate }}
          </ion-button>
        </ion-item>
      </section>

      <section class="payment-section payment-collapsible-section">
        <h2
          class="payment-section-title collapsible-section-toggle"
          (click)="togglePaymentMethodsSection()"
          role="button"
          tabindex="0"
          (keydown.enter)="togglePaymentMethodsSection()"
          (keydown.space)="togglePaymentMethodsSection(); $event.preventDefault()"
        >
          <span class="payment-section-heading">
            {{ 'PAYMENT.PAYMENT_METHODS' | translate }}
            <span class="payment-section-summary">{{ paymentMethodsSummary }}</span>
          </span>
          <ion-icon [name]="showPaymentMethodsSection ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
        </h2>
        <div *ngIf="showPaymentMethodsSection" class="payment-section-body">
          <div *ngIf="shouldShowPaymentEditor()" class="payment-dropin-wrap">
            <app-account-payment
              #paymentsForm
              (startEdit)="startEditing(true)"
              [accountInformation]="accountInformation"
              [canAdminister]="canAdminister"
              [editing]="!!canAdminister"
            ></app-account-payment>
          </div>
          <ion-list *ngIf="!shouldShowPaymentEditor() && paymentMethods.length" lines="none" class="payment-methods-list">
            <ion-item *ngFor="let method of paymentMethods">
              <ion-label>
                <p>{{ method.masked }}</p>
                <p *ngIf="method.expiration" class="payment-method-meta">
                  {{ 'PAYMENT.EXPIRES' | translate }} {{ method.expiration }}
                </p>
              </ion-label>
              <ion-badge *ngIf="method.default" slot="end" color="primary">{{ 'PAYMENT.DEFAULT' | translate }}</ion-badge>
            </ion-item>
          </ion-list>
          <p *ngIf="!shouldShowPaymentEditor() && !paymentMethods.length" class="payment-empty ion-padding-horizontal">
            {{ 'PAYMENT.NO_PAYMENT_METHODS' | translate }}
          </p>
        </div>
      </section>

      <section class="payment-section payment-collapsible-section">
        <h2
          class="payment-section-title collapsible-section-toggle"
          (click)="toggleTransactionHistorySection()"
          role="button"
          tabindex="0"
          (keydown.enter)="toggleTransactionHistorySection()"
          (keydown.space)="toggleTransactionHistorySection(); $event.preventDefault()"
        >
          <span class="payment-section-heading">
            {{ 'PAYMENT.TRANSACTION_HISTORY' | translate }}
            <span *ngIf="transactionsSummary" class="payment-section-summary">{{ transactionsSummary }}</span>
          </span>
          <ion-icon [name]="showTransactionHistorySection ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
        </h2>
        <div *ngIf="showTransactionHistorySection" class="payment-section-body">
          <div *ngIf="transactionsLoading" class="payment-transactions-loading">
            <ion-spinner name="crescent"></ion-spinner>
          </div>
          <ion-list *ngIf="!transactionsLoading && transactions.length" lines="full" class="payment-transactions-list">
            <ion-item *ngFor="let tx of transactions">
              <ion-label>
                <h3>{{ formatTransactionDate(tx.createdAt) }}</h3>
                <p>{{ tx.type }} · {{ tx.status }}</p>
                <p class="payment-transaction-id">{{ tx.id }}</p>
              </ion-label>
              <ion-note slot="end">{{ formatTransactionAmount(tx) }}</ion-note>
            </ion-item>
          </ion-list>
          <p *ngIf="!transactionsLoading && !transactions.length" class="payment-empty ion-padding-horizontal">
            {{ 'PAYMENT.NO_TRANSACTIONS' | translate }}
          </p>
        </div>
      </section>
    </form>

    <ion-row class="payment-actions ion-justify-content-end ion-padding-end">
      <ion-button
        size="small"
        type="submit"
        *ngIf="shouldShowPrimarySubmit"
        [disabled]="updatePending || !canSubmit()"
        (click)="save()"
      >
        {{ submitButtonLabelKey | translate }}
      </ion-button>
      <div *ngIf="updatePending" class="submitpending">
        <ion-spinner name="bubbles"></ion-spinner>
        <span>{{ 'GENERAL.UPDATING' | translate }}</span>
      </div>
    </ion-row>
  </ng-template>
</div>
